import styled from "styled-components";
import { Brick } from "../../Masonry";

const StyledBrick = styled(Brick)`
  box-sizing: border-box;
  border: 1px solid #000;
  width: 100%;
  height: 100%;
  user-select: none;
`;

export default StyledBrick;
